import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { storage } from '@uhg-abyss/web/tools/storage';

import { config } from '@uhg-abyss/web/tools/config';
import { useReloadPopup } from '@src/state/reloadPopup/hooks';

import { IdleTimer } from './IdleTimer';
import { IdleModal } from './IdleModal';
import { HAS_SIGNED_OUT } from './constants';

export const IdleUser = ({ data, events }) => {
  const [idleModalOpen, setIdleModalOpen] = useState(false);
  const { setReloadPopup } = useReloadPopup.actions();

  useEffect(() => {
    storage.local.set(HAS_SIGNED_OUT, false);
  }, []);

  const onIdle = () => {
    setIdleModalOpen(true);
    setReloadPopup(false);
  };

  const closeIdleModal = () => {
    setIdleModalOpen(false);
    setReloadPopup(true);
  };

  return (
    <IdleTimer
      modalOpen={idleModalOpen}
      eventTimeout={data.eventTimeout}
      idleTimeout={data.idleTimeout}
      onIdle={onIdle}
      onActive={events.onActive}
    >
      <IdleModal
        timeRemaining={data.timeRemaining}
        pingInterval={data.pingInterval}
        events={events}
        isOpen={idleModalOpen}
        closeModal={closeIdleModal}
      />
    </IdleTimer>
  );
};

IdleUser.propTypes = {
  data: PropTypes.shape({
    eventTimeout: PropTypes.number,
    idleTimeout: PropTypes.number,
    timeRemaining: PropTypes.number,
    pingInterval: PropTypes.number,
  }),
  events: PropTypes.shape({
    onActive: PropTypes.func,
    showIdleRecovery: PropTypes.func,
  }).isRequired,
};

IdleUser.defaultProps = {
  data: {
    eventTimeout: 10000, // 10 seconds to refresh event timeout
    idleTimeout: config('IDLE_TIMEOUT_TIME'), // 30 minutes to show modal
    timeRemaining: config('MODEL_IDLE_TIME'), // 10 minutes on modal countdown
    pingInterval: 30000, // 5 minutes on idle ping
  },
};
